<template>
  <div v-bind="$attrs">
    <WarningSecurityContactModal
            v-if="WarningSecurityContactModalState"
            :isOpen="WarningSecurityContactModalState"
            :warningList="storeItem.warnings"
            :phoneNumber="storeItem.phone"
            :phoneNumber2="storeItem.phone2 || null"
            :whatsAppNumber="storeItem.whatsapp"
            @close="WarningSecurityContactModalState = false"
          />
    <section>
        <div class="flex flex-wrap gap-y-0 md:flex-nowrap md:gap-y-4 md:gap-x-7">
            <!-- contact info -->
            <div :class="`${storeAddress ? 'rounded-[11px_11px_0_0] md:rounded-[11px]' :'rounded-[11px]'} w-full lg:w-1/2 p-2 px-2.5 md:p-4  bg-white border border-[#f3f3f3]`.trim()">
                <div class="flex flex-wrap gap-3 md:gap-1.5 justify-between">
                    <div>
                        <StoreSectionTitle :title="$t('user.store.connect')" class="mb-2 md:mb-3 mt-1.5" />
                        <div class="flex flex-wrap items-center gap-y-2">
                            <!-- connection -->
                            <div
                                :class="`${ showSocialDivider ? 'border-[#70707030] rtl:lg:border-l-[2px] ltr:lg:border-r-[2px] rtl:pl-2.5 ltr:pr-2.5' : 'border-0' } py-1.5 flex items-baseline gap-0.5`">
                                <button :class="`${isCreatingChat ? 'disabled' : ''} !outline-none px-1`.trim()
                    " :disabled="isCreatingChat" title="chat with reseller" @click="() => startChat()">
                                    <ChatIcon
                                        class="w-[1.4rem] sm:w-[1.625rem] 3xl:w-[1.68rem] h-auto hover:translate-y-[-2px] linear duration-200" />
                                </button>
                                <button v-if="storeWhatsapp" @click="handleWhatsAppClick" class="!outline-none px-1" title="Reach them via Whatsapp">
                                 
                                    <WhatsappIcon
                                        class="w-[1.625rem] 3xl:w-[1.68rem] h-auto hover:translate-y-[-2px] linear duration-200" />
                                </button>
                                <button v-if="storePhone1" title="Call store's phone number" @click="() => { handleWhatsAppClick(); triggerContactPixelEvent(); }"
                                    class="!outline-none px-1">
                                    <PhoneIcon
                                        class="w-[1.4rem] sm:w-[1.5rem] 3xl:w-[1.56rem] h-auto hover:translate-y-[-2px] linear duration-200" />
                                    <span class="sr-only">call {{ storePhone1 }}</span>
                                </button>
                                <!-- <button v-if="storePhone2" title="Call store's secondary phone number" @click="() => { handleWhatsAppClick(); triggerContactPixelEvent(); }"
                                    class="!outline-none px-1">
                                    <PhoneIcon
                                        class="w-[1.4rem] sm:w-[1.5rem] 3xl:w-[1.56rem] h-auto hover:translate-y-[-2px] linear duration-200" />
                                    <span class="sr-only">call {{ storePhone2 }}</span>
                                </button> -->
                            </div>
                            <!-- socials -->
                            <ul ref="socialsContainer" class="list-none flex flex-wrap gap-2 md:gap-2.5 lg:gap-3.5 py-1.5 rtl:lg:pr-2.5 ltr:lg:pl-2.5">
                                <li v-if="storeFacebook" class="m-auto">
                                    <a :href="storeFacebook" @click="triggerContactPixelEvent" rel="noopener noreferrer"
                                        target="_blank" title="Find us on Facebook">
                                        <img src="@/assets/store/facebook.svg"
                                            class="object-contain hover:translate-y-[-2px] linear duration-200 w-[0.64rem] sm:w-[0.75rem] h-auto"
                                            width="12" height="12" alt />
                                    </a>
                                </li>
                                <li v-if="storeInstagram" class="m-auto" >
                                    <a :href="storeInstagram" @click="triggerContactPixelEvent" rel="noopener noreferrer"
                                        target="_blank" title="Find us on Instagram">
                                        <img src="@/assets/store/instagram.svg"
                                            class="object-contain hover:translate-y-[-2px] linear duration-200 w-[1.4rem] sm:w-[1.75rem] h-auto"
                                            width="28" height="28" alt />
                                    </a>
                                </li>
                                <li v-if="storeTelegram" class="m-auto">
                                    <a :href="storeTelegram" @click="triggerContactPixelEvent" rel="noopener noreferrer"
                                        target="_blank" title="Find us on telegram">
                                        <img src="@/assets/store/telegram.svg"
                                            class="object-contain hover:translate-y-[-2px] linear duration-200 w-[1.4rem] sm:w-[1.625rem] h-auto"
                                            width="26" height="26" alt />
                                    </a>
                                </li>
                                <li v-if="storeLinkedIn" class="m-auto">
                                    <a :href="storeLinkedIn" @click="triggerContactPixelEvent" rel="noopener noreferrer"
                                        target="_blank" title="Find us on linkedin">
                                        <img src="@/assets/store/linkedin2.svg"
                                            class="object-contain hover:translate-y-[-2px] linear duration-200 w-[1.1rem] sm:w-[1.125rem] h-auto"
                                            width="18" height="18" alt />
                                    </a>
                                </li>
                                <li v-if="storeTwitter" class="m-auto">
                                    <a :href="storeTwitter" @click="triggerContactPixelEvent" rel="noopener noreferrer"
                                        target="_blank" title="Find us on Twitter">
                                        <img src="@/assets/store/twitter.svg"
                                            class="object-contain hover:translate-y-[-2px] linear duration-200 w-[1.4rem] sm:w-[1.75rem] h-auto"
                                            width="28" height="28" alt />
                                    </a>
                                </li>
                                <li v-if="storeYoutube" class="m-auto">
                                    <a :href="storeYoutube" @click="triggerContactPixelEvent" rel="noopener noreferrer"
                                        target="_blank" title="Find us on YouTube">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="w-[20px]" viewBox="0 0 24 24" fill="red">
                                            <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
                                        </svg>
                                    </a>
                                </li>
                                <!-- <li v-if="storeWhatsapp" class="m-auto">
                                    <WhatsappButton :whatsappNumber="storeWhatsapp"
                                        :message="$t('general.store_whatsapp_message')" />
                                </li> -->


                            </ul>
                        </div>
                    </div>
                    <!-- QR Code -->
                    <div class="flex gap-2">
                        <div id="qrCode" @dblclick="handleSaveImg" class="cursor-pointer my-auto" :title="$t('general.save_qr')">
                            <div class="relative">
                                <Qrcode :tooltipTitle="$t('general.save_qr')" :value="storeCurrentURL" class="qr-code main-tooltip " draggable="false" :size="72" level="H" /> 
                                <i class="absolute z-[1] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]  w-[24px] h-[24px] md:w-[30px] md:h-[30px] select-none">
                                    <img src="@/assets/defaultImg.png" alt />
                                </i>
                                <button @click="handleSaveImg" aria-label="Download QR Code" class="absolute z-[1] bottom-[-0.513rem] md:bottom-[-0.6rem] rtl:right-[-0.213rem] ltr:left-[-0.213rem] rtl:md:right-[-0.8rem] ltr:md:left-[-0.813rem] grid place-content-center hover:brightness-110 duration-150 w-[2rem] h-[2rem] rounded-full overflow-hidden">
                                    <i class="inline-block bg-primary p-2 w-full h-auto">
                                        <img src="@/assets/icons/download.svg" class="w-[0.938rem] h-[0.938rem] m-auto object-contain" alt width="15" height="15" />
                                    </i>
                                </button>
                            </div>

                            <Qrcode ref="highSizeQrRef" :value="storeCurrentURL" class="h-[55px] w-[55px] hidden"
                                :size="350" level="H" />
                            <a ref="QrcodeRef" href="" class="hidden" download></a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- address -->
            <div v-if="storeAddress" :class="`${storeAddress ? 'rounded-[0_0_11px_11px] md:rounded-[11px]' :'rounded-[11px]'} w-full lg:w-1/2 p-2 px-2.5 md:p-4  bg-white border border-[#f3f3f3]`.trim()">
                <!-- <div class="flex flex-wrap lg:flex-nowrap justify-between h-full"> -->
                    <div class="w-full h-full">
                        <div class="flex justify-between">
                            <StoreSectionTitle :title="$t('user.store.address')" class="mb-2 md:mb-3 mt-1.5" />
                            <a v-if="storeItem.location" :href="formatedLocationLink" class="flex self-start gap-1.5 flex-nowrap items-center text-primary hover:brightness-95 duration-150 transition-[filter] text-[0.8rem] md:text-[1rem] 3xl:text-[1.063rem] font-normal" rel="noopener noreferrer" target="_blank">
                                <img src="@/assets/store/bi_pin-map.svg" class="w-[0.85rem] h-[0.85rem] md:w-[0.9rem] md:h-[0.9rem] lg:w-[1rem] lg:h-[1rem] object-contain" alt
                                    :width="14" :height="14" />
                                <span>{{ $t("user.store.view_on_google_maps") }}</span>
                            </a>
                        </div>
                        
                        <div class="inline-flex items-center gap-1.5 md:gap-2 mt-1.5 text-black" style="overflow-wrap: anywhere;">
                            <img src="@/assets/icons/location.svg" class="w-[0.85rem] md:w-[0.9rem] lg:w-[1rem] h-auto object-contain" alt
                            :width="14" :height="14" />
                            <span class="inline-block ellipsis-x2 text-[1rem] lg:text-[1.055rem] 3xl:text-[1.063rem]">{{ storeAddress }}</span>
                        </div>
                    </div>
            </div>
        </div>

        <div class="block xl:hidden w-full mt-6 pt-3 pb-4 px-2.5 rounded-[11px] bg-white border border-[#f3f3f3]">
            <StoreSectionTitle :title="$t('user.store_categories')" class="mb-2" />
            <StoreCategoriesSection :list="storeCategoriesList" :finalizedNameKey="finalizedNameKey" />
        </div>
  
    </section>
  </div>
</template>

<script>
import { generateTelegramLink , generateWhatsappLink ,ROUTESNAMES, APIREQUESTS, MAINROLES, } from "@/helpers";
import StoreCategoriesSection from "./StoreCategoriesSection.vue";
import StoreSectionTitle from "./StoreSectionTitle.vue";
import ChatIcon from "@/assets/shared/icons/ChatOutline.vue";
import WhatsappIcon from "@/assets/shared/icons/WhatsappOutline.vue";
import PhoneIcon from "@/assets/shared/icons/PhoneOutline.vue";
import WhatsappButton from "@/components/user/WhatsappButton.vue";
import Qrcode from "qrcode.vue";
import { useGlobalStore } from "@/store/Modules/global";
import WarningSecurityContactModal from "@/components/user/WarningSecurityContactModal.vue";
export default {
    name: 'StoreContactInfo',
    inheritAttrs: false,
    data() {
        return {
            isCreatingChat: false,
            showSocialDivider: false,
            WarningSecurityContactModalState: false,
        };
    },
    props: {
        storeItem: {
            type: Object,
            default: () => ({}),
        },
        storeCurrentURL: {
            type: String,
            required: true,
            default: ""
        },
        finalizedNameKey: {
            type: String,
            required: true,
            default: "name_ar",
        },
        storeCategoriesList: {
            type: Array,
            required: true,
            default: () => ([]),
        },
    },
    computed: {
        formattedWhatsappLink() {
            return generateWhatsappLink({ phone_number: this.storeItem?.whatsapp, link: window?.location?.href || "" });
        },
    
        storeAddress() {
            return this.storeItem?.address;
        },
        storeLocation() {
            return this.storeItem?.location;
        },
        storePhone1() {
            return this.storeItem?.phone;
        },
        storePhone2() {
            return this.storeItem?.phone2;
        },
        storeFacebook() {
            return this.storeItem?.facebook;
        },
        storeTelegram() {
            return generateTelegramLink(this.storeItem?.telegram);
        },
        storeLinkedIn() {
            return this.storeItem?.linkedin;
        },
        storeTwitter() {
            return this.storeItem?.twitter;
        },
        storeYoutube() {
            return this.storeItem?.youtube;
        },
        storeWhatsapp() {
            return this.storeItem?.whatsapp;
        },
        storeInstagram() {
            return this.storeItem?.instagram;
        },
        formatedLocationLink() {
            let regexLocationPattern = /^https:\/\/www\.google\.com\/maps\?q=-?\d+(\.\d+)?,-?\d+(\.\d+)?$/;
            if (this.storeItem?.location) {
                if (regexLocationPattern.test(this.storeItem.location)) {
                    //check if it came as a link or lat,lng
                    return this.storeItem.location;
                } else {
                    let coordinatesArr = this.storeItem.location.split(",");
                    return `https://maps.google.com/maps?q=${coordinatesArr[0]},${coordinatesArr[1]}`;
                }
            }
        },
    },
    methods: {
        handleWhatsAppClick(){
            this.WarningSecurityContactModalState = true;
        },
        startChat() {
      const id = this.storeItem.id;
      const UID = useCookie?.("UID")?.value ? useCookie?.("UID")?.value : false;
      this.makeRequest({
        owner: MAINROLES.user,
        method: APIREQUESTS.user.createChat.method,
        url: `${APIREQUESTS.user.createChat.url}/${UID}/${id}`,
      })
        .then(res => {
          this.isCreatingChat = false;
          // failed
          if (res?.message !== 'Response Successfully') {
            this.notify({
              type: "error",
              msg: res.message
            });
          } else {
            // succeeded
            if (res?.data) {
              useGlobalStore().updateForwardedStore(res.data);
              this.$router.push(`${this.ROUTESNAMES.user.chats}?id=${res.data || ''}`).then(() => {
                this.$router.go();
              });
            }
          }
        })
        .catch(err => {
          this.notify({
            type: "error",
            msg: err || this.$t('general.message_sending_failed')
          });
          this.isCreatingChat = false;

          if (err.status == 402) {
            //store phone  and email token in local storage
            const tempTokens = {
              phone: err?.data?.data?.token?.phone_token,
              email: err?.data?.data?.token?.email_token
            };
            this.useLocalStorage({ type: 'set', key: 'tempTokens', value: tempTokens });

            //go to otp-email
            this.$router.push('/otp?by=email&page=login')

          } else if (err.status == 403) {
            //store email token in local storage
            const tempTokens = {
              email: err?.data?.data?.token?.email_token
            };
            this.useLocalStorage({ type: 'set', key: 'tempTokens', value: tempTokens });

            //go to otp-email
            this.$router.push('/otp?by=email&page=login')
          }
        });
    },
        triggerContactPixelEvent() {
            fbq("track", "Contact");
        },
        handleSaveImg() {
            try {
                // Wait for next tick to ensure DOM is updated
                this.$nextTick(() => {
                    // Try multiple approaches to find the canvas
                    let canvas = null;
                    
                    console.log('Starting canvas search...');
                    console.log('this.$refs.qrCode:', this.$refs.qrCode);
                    console.log('this.$refs.highSizeQrRef:', this.$refs.highSizeQrRef);
                    
                    // Method 1: Look for canvas in the visible QR code (the one with size 72)
                    const visibleQrCode = this.$refs.qrCode;
                    if (visibleQrCode) {
                        console.log('Visible QR code ref found, searching for canvas...');
                        try {
                            if (typeof visibleQrCode.querySelector === 'function') {
                                canvas = visibleQrCode.querySelector('canvas');
                                console.log('Canvas found in visible QR code:', canvas);
                            } else {
                                console.log('visibleQrCode.querySelector is not a function');
                            }
                        } catch (err) {
                            console.log('Error in Method 1:', err);
                        }
                    }
                    
                    // Method 2: If not found, try the highSizeQrRef
                    if (!canvas && this.$refs.highSizeQrRef) {
                        const highSizeQr = this.$refs.highSizeQrRef;
                        console.log('High size QR ref found, trying to access $el...');
                        try {
                            // Check if $el exists and has querySelector method
                            if (highSizeQr.$el && typeof highSizeQr.$el.querySelector === 'function') {
                                canvas = highSizeQr.$el.querySelector('canvas');
                                console.log('Canvas found in highSizeQr.$el:', canvas);
                            } else if (highSizeQr.$el && highSizeQr.$el.tagName === 'CANVAS') {
                                // If $el is directly a canvas element
                                canvas = highSizeQr.$el;
                                console.log('highSizeQr.$el is directly a canvas:', canvas);
                            } else if (highSizeQr.$el && highSizeQr.$el.querySelectorAll) {
                                // Try querySelectorAll as fallback
                                const canvases = highSizeQr.$el.querySelectorAll('canvas');
                                if (canvases.length > 0) {
                                    canvas = canvases[0];
                                    console.log('Canvas found using querySelectorAll:', canvas);
                                }
                            } else {
                                console.log('highSizeQr.$el structure:', highSizeQr.$el);
                            }
                        } catch (err) {
                            console.log('Error accessing highSizeQr.$el:', err);
                        }
                    }
                    
                    // Method 3: Search for any canvas in the entire component
                    if (!canvas) {
                        console.log('Trying to search entire component for canvas...');
                        try {
                            const allCanvases = this.$el.querySelectorAll('canvas');
                            console.log('Found canvases in component:', allCanvases.length);
                            if (allCanvases.length > 0) {
                                canvas = allCanvases[0]; // Use the first canvas found
                                console.log('Using first canvas from component:', canvas);
                            }
                        } catch (err) {
                            console.log('Error in Method 3:', err);
                        }
                    }
                    
                    // Method 4: Use the visible QR code directly if it has a canvas
                    if (!canvas && visibleQrCode) {
                        console.log('Trying to create canvas from image...');
                        try {
                            const img = visibleQrCode.querySelector('img');
                            if (img) {
                                // Create a canvas from the image
                                canvas = document.createElement('canvas');
                                const ctx = canvas.getContext('2d');
                                canvas.width = img.naturalWidth || 72;
                                canvas.height = img.naturalHeight || 72;
                                ctx.drawImage(img, 0, 0);
                                console.log('Canvas created from image:', canvas);
                            }
                        } catch (err) {
                            console.log('Error in Method 4:', err);
                        }
                    }

                    if (!canvas) {
                        console.error('QR code canvas not found after trying all methods');
                        console.log('Final state - no canvas found');
                        return;
                    }

                    console.log('Canvas found successfully:', canvas);

                    const borderWidth = 20;
                    const borderColor = "white";

                    // Create a new canvas for the border
                    const borderCanvas = document.createElement("canvas");
                    const context = borderCanvas.getContext("2d");
                    borderCanvas.width = canvas.width + 2 * borderWidth;
                    borderCanvas.height = canvas.height + 2 * borderWidth;

                    // Draw the border on the borderCanvas
                    context.fillStyle = borderColor;
                    context.fillRect(0, 0, borderCanvas.width, borderCanvas.height);

                    // Draw the original QR code on top of the border
                    context.drawImage(canvas, borderWidth, borderWidth);

                    const imageURL = borderCanvas.toDataURL();
                    
                    // Create temporary link element
                    const downloadLink = document.createElement('a');
                    downloadLink.href = imageURL;
                    downloadLink.download = 'qr-code.png';
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                });
            } catch (error) {
                console.error('Error saving QR code image:', error);
            }
        },
        handleStorePhoneClick() {
            if (this.storePhone2) {
                this.WarningSecurityContactModalState = true;
            } else if (this.storePhone1) {
                window.location.href = `tel:${this.storePhone1}`;
            }
        },
    },
    components: {
        WarningSecurityContactModal,
        Qrcode,
        StoreSectionTitle,
        WhatsappButton,
        ChatIcon,
        PhoneIcon,
        WhatsappIcon,
        StoreCategoriesSection,
    },
    mounted(){
        const socialsContainerRef = this.$refs.socialsContainer;
        if(socialsContainerRef){
            this.showSocialDivider = socialsContainerRef.querySelectorAll('li')?.length > 0;
        }
    }
};
</script>

<style lang="scss">

#qrCode .qr-code {
    @media only screen and (min-width: 1024px) {
        width: 4.875rem !important;
        height: 4.875rem !important;
    }
    @media (min-width: 819px) and (max-width: 1024px) {
        width: 4.513rem !important;
        height: 4.513rem !important;
    }
    @media (min-width: 640px) and (max-width: 819px) {
        width: 4.513rem !important;
        height: 4.513rem !important;
    }
    @media only screen and (max-width: 640px) {
        width: 3.438rem !important;
        height: 3.438rem !important;
    }
}
</style>
